import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import './Theme/plugins/mediaelement4/mediaelementplayer.min.css';
import $ from 'jquery';
import AudioPageApi from './AudioPageApi';
import HomePageApi from './HomePageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');

function AudioPage() {

  const [searchParams] = useSearchParams();
  const postId = searchParams.get('id');
  const [dataChiTiet, setDataChiTiet] = useState({});
  const [activeTab, setActiveTab] = useState('MoiNhat');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [thongKe, setThongKe] = useState([]);


  document.addEventListener('DOMContentLoaded', () => {
    const audio = document.getElementById('mainplayler_html5');
    let isHandlingClick = false; // Flag to prevent double handling

    if (audio) {
      const parentPlayPauseButton = document.querySelector('.mejs__playpause-button');
      const playPauseButton = document.querySelector('.mejs__playpause-button button');
      if (playPauseButton) {
        // Function to handle play/pause
        const handlePlayPause = () => {
          // If already handling a click, do nothing
          if (isHandlingClick) return;
          isHandlingClick = true; // Set flag

          // Play or pause the audio based on its current state
          if (audio.paused) {
            audio.play();
            playPauseButton.setAttribute('title', 'Pause');
            playPauseButton.setAttribute('aria-label', 'Pause');
            parentPlayPauseButton.classList.remove('mejs__play');
            parentPlayPauseButton.classList.add('mejs__pause');
          } else {
            audio.pause();
            playPauseButton.setAttribute('title', 'Play');
            playPauseButton.setAttribute('aria-label', 'Play');
            parentPlayPauseButton.classList.remove('mejs__pause');
            parentPlayPauseButton.classList.add('mejs__play');
          }

          // Reset the flag after a short delay
          setTimeout(() => {
            isHandlingClick = false; // Reset flag
          }, 200); // Adjust delay as necessary
        };

        // Remove existing event listeners to prevent duplication
        const newButton = playPauseButton.cloneNode(true);
        playPauseButton.parentNode.replaceChild(newButton, playPauseButton);
        newButton.addEventListener('click', handlePlayPause);
      } else {
        console.error('Play/pause button not found!');
      }

      // Update current time display
      audio.addEventListener('timeupdate', () => {
        const currentTimeElement = document.querySelector('.mejs__currenttime');
        if (currentTimeElement) {
          const currentMinutes = Math.floor(audio.currentTime / 60);
          const currentSeconds = Math.floor(audio.currentTime % 60).toString().padStart(2, '0');
          currentTimeElement.textContent = `${currentMinutes}:${currentSeconds}`;
        }

        // Update time slider (scaleX for progress bar)
        const currentScale = audio.currentTime / audio.duration;
        const timeCurrent = document.querySelector('.mejs__time-current');
        if (timeCurrent) {
          timeCurrent.style.transform = `scaleX(${currentScale})`;
        }

        const timeHandle = document.querySelector('.mejs__time-handle');
        if (timeHandle) {
          timeHandle.style.transform = `translateX(${currentScale * 100}%)`;
        }
      });

      // Time slider drag/hover functionality
      const timeSlider = document.querySelector('.mejs__time-slider');
      if (timeSlider) {
        timeSlider.addEventListener('mousedown', (event) => {
          const rect = timeSlider.getBoundingClientRect();
          const clickPosition = (event.clientX - rect.left) / rect.width;
          const newTime = clickPosition * audio.duration;
          audio.currentTime = newTime;
        });

        timeSlider.addEventListener('mousemove', (event) => {
          if (event.buttons === 1) {
            const rect = timeSlider.getBoundingClientRect();
            const hoverPosition = (event.clientX - rect.left) / rect.width;
            const hoverTime = hoverPosition * audio.duration;
            audio.currentTime = hoverTime;
          }
        });
      } else {
        console.error('Time slider not found!');
      }

      // Total time display
      audio.addEventListener('loadedmetadata', () => {
        const totalTimeElement = document.querySelector('.mejs__duration');
        if (totalTimeElement) {
          const totalMinutes = Math.floor(audio.duration / 60);
          const totalSeconds = Math.floor(audio.duration % 60).toString().padStart(2, '0');
          totalTimeElement.textContent = `${totalMinutes}:${totalSeconds}`;
        } else {
          console.error('Total time element not found!');
        }
      });

      // Mute Functionality
      const muteButton = document.querySelector('.mejs__mute button');
      if (muteButton) {
        muteButton.addEventListener('click', () => {
          audio.muted = !audio.muted; // Toggle mute
          muteButton.setAttribute('title', audio.muted ? 'Unmute' : 'Mute');
          muteButton.setAttribute('aria-label', audio.muted ? 'Unmute' : 'Mute');
        });
      }

      // Volume Slider Functionality
      const volumeSlider = document.querySelector('.mejs__horizontal-volume-slider');
      if (volumeSlider) {
        const volumeHandle = volumeSlider.querySelector('.mejs__horizontal-volume-handle');
        const volumeCurrent = volumeSlider.querySelector('.mejs__horizontal-volume-current');

        // Update volume based on slider position
        volumeSlider.addEventListener('mousedown', (event) => {
          const rect = volumeSlider.getBoundingClientRect();
          const clickPosition = (event.clientX - rect.left) / rect.width;
          const newVolume = Math.min(Math.max(clickPosition, 0), 1); // Clamp value between 0 and 1
          audio.volume = newVolume;
          updateVolumeDisplay(newVolume);
        });

        // Update volume while dragging
        volumeSlider.addEventListener('mousemove', (event) => {
          if (event.buttons === 1) {
            const rect = volumeSlider.getBoundingClientRect();
            const hoverPosition = (event.clientX - rect.left) / rect.width;
            const newVolume = Math.min(Math.max(hoverPosition, 0), 1); // Clamp value
            audio.volume = newVolume;
            updateVolumeDisplay(newVolume);
          }
        });

        // Update the volume display based on the current volume
        function updateVolumeDisplay(newVolume) {
          volumeCurrent.style.width = `${newVolume * 100}%`;
          volumeHandle.style.left = `${newVolume * 100}%`;
          volumeSlider.setAttribute('aria-valuenow', newVolume * 100);
          volumeSlider.setAttribute('aria-valuetext', `${Math.round(newVolume * 100)}%`);
        }

        // Initialize volume display on load
        updateVolumeDisplay(audio.volume);
      }
    } else {
      console.error('Audio element not found!');
    }
  });

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });

    AudioPageApi.getChitietVideo(postId).then((data) => {
      console.log('postId: ', postId)
      if (data && data.length > 0) {
        const dateStr = data[0].Date_Create;
        if (dateStr) {
          const date = new Date(dateStr);
          const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
          data[0].Date_Create = formattedDate;
        }
        setDataChiTiet(data[0]); // Update state with the resolved data
      }
    })

    handleTabClick('MoiNhat');

    HomePageApi.getDataThongKe().then((data) => {
      setThongKe(data); // Update state with the resolved data
    })

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset to first page on tab change
    callApi(tab, 1);
  };

  const callApi = (tab, currentPage) => {
    switch (tab) {
      case 'MoiNhat':
        AudioPageApi.getAudioMoiNhat(currentPage).then((data) => {
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      case 'XemNhieu':
        AudioPageApi.getAudioXemNhieu(currentPage).then((data) => {
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      case 'TaiNhieu':
        AudioPageApi.getAudioTaiNhieu(currentPage).then((data) => {
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      default:
        break;
    }
  }

  const handlePageClick = (page) => {
    setCurrentPage(page);
    callApi(activeTab, page);
  };

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"audio"} />
              {/* content video */}
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="videoContainer">
                    <span className="mejs__offscreen">Audio Player</span>
                    <div id="mep_0"
                      className="mejs__container mejs__audio mejs__long-video mejs__container-keyboard-inactive"
                      tabIndex={0}
                      role="application"
                      aria-label="Audio Player"
                      style={{ width: '533px', height: '306.322px', minWidth: '273px' }}>

                      <div className="mejs__inner">
                        <div className="mejs__mediaelement">
                          <mediaelementwrapper id="mainplayler">
                            <audio className
                              autoPlay="autoplay"
                              poster="/Upload/images/7a840dd6c2f118af41e0.jpg"
                              preload="none"
                              alt={dataChiTiet.title}
                              title={dataChiTiet.title}
                              id="mainplayler_html5"
                              width={533}
                              height="306.32183908045977"
                              src={FILE_URL + dataChiTiet.linkMp3}>

                              <source src={FILE_URL + dataChiTiet.linkMp3}
                                type="audio/mp3" />
                            </audio>
                          </mediaelementwrapper>
                        </div>

                        <div className="mejs__layers">
                          <div className="mejs__poster mejs__layer"
                            style={{
                              backgroundImage: 'url("https://web2.linhquyphapan.vn/Upload/images/7a840dd6c2f118af41e0.jpg")',
                              width: '533px',
                              height: '306.322px',
                              display: 'none'
                            }}>
                            <img className="mejs__poster-img"
                              width={0}
                              height={0}
                              src="/Upload/images/7a840dd6c2f118af41e0.jpg" />
                          </div>
                        </div>

                        <div className="mejs__controls">
                          <div className="mejs__button mejs__playpause-button mejs__pause">
                            <button type="button"
                              aria-controls="mep_0"
                              title="Play"
                              aria-label="Play"
                              tabIndex={0} />
                          </div>

                          <div className="mejs__time mejs__currenttime-container"
                            role="timer"
                            aria-live="off">
                            <span className="mejs__currenttime">00:03:32</span>
                          </div>

                          <div className="mejs__time-rail">
                            <span className="mejs__time-total mejs__time-slider"
                              role="slider"
                              tabIndex={0}
                              aria-label="Time Slider"
                              aria-valuemin={0}
                              aria-valuemax="5790.641633"
                              aria-valuenow="211.757451"
                              aria-valuetext="00:03:32">

                              <span className="mejs__time-buffering" style={{ display: 'none' }} />
                              <span className="mejs__time-loaded" style={{ transform: 'scaleX(0.0807)' }} />
                              <span className="mejs__time-current" style={{ transform: 'scaleX(0.038328)' }} />
                              <span className="mejs__time-hovered no-hover"
                                pos="39.453125"
                                style={{ left: '6px', transform: 'scaleX(0.128219)' }} />
                              <span className="mejs__time-handle" style={{ transform: 'translateX(6px)' }}>
                                <span className="mejs__time-handle-content" />
                              </span>
                              <span className="mejs__time-float" style={{ display: 'none', left: '59.9531px' }}>
                                <span className="mejs__time-float-current">00:14:35</span>
                                <span className="mejs__time-float-corner" />
                              </span>
                            </span>
                          </div>

                          <div className="mejs__time mejs__duration-container">
                            <span className="mejs__duration">01:36:31</span>
                          </div>

                          <div className="mejs__button mejs__volume-button mejs__mute">
                            <button type="button"
                              aria-controls="mep_0"
                              title="Mute"
                              aria-label="Mute"
                              tabIndex={0} />
                          </div>

                          <a className="mejs__horizontal-volume-slider"
                            href="javascript:void(0);"
                            aria-label="Volume Slider"
                            aria-valuemin={0}
                            aria-valuemax={100}
                            role="slider"
                            aria-valuenow={80}
                            aria-valuetext="80%">

                            <span className="mejs__offscreen">Use Up/Down Arrow keys to increase or decrease volume.</span>
                            <div className="mejs__horizontal-volume-total">
                              <div className="mejs__horizontal-volume-current"
                                style={{ left: '0px', width: '80%' }} />
                              <div className="mejs__horizontal-volume-handle" style={{ left: '80%' }} />
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="chiTietVideoAudio">
                    <div className="row">
                      <div className="col-md-6">
                        <h1>
                          {dataChiTiet.title}
                        </h1>
                        <p>{dataChiTiet.Description}</p>
                        <p>Ngày đăng : {dataChiTiet.Date_Create}</p>
                      </div>
                      <div className="col-md-6">
                        <div className="sharethis">
                          <span className="viewed-count"><strong>Lượt xem: </strong>{dataChiTiet.ViewedCount}</span>
                          <span className="st_googleplus_large" displaytext="Google +" />
                          <span className="st_facebook_large" displaytext="Facebook" />
                        </div>
                        <div className="downloadvideo">
                          <a className="btn" href="javascript:;" onclick="turnofflight()">
                            <i className="fa fa-power-off" /> Tắt đèn
                          </a>
                          <a className="btnAddFav btn" data-id={30397} data-type="audio" data-title="Kinh NIKAYA Giảng Giải - Thánh Trí Về Khát Ái 6 - Kinh Khúc Gỗ Trôi Ra Biển">
                            <i className="fa fa-plus" /> Thêm vào
                          </a>
                          <form action="/Download/File/30397?type=audio" className id="formDownload" method="post"><input name="__RequestVerificationToken" type="hidden" defaultValue="s_dWEnctWf0zhyz0mMUXCtplpqc32VrYkGZOvhtL259TF-FaJhg_KrJGqiBWdYBRlk43z0_oKQUI2Dc1JNyYkUCUVvk1" />                            <a download className="btn btn-downloadfile" onclick="document.getElementById('formDownload').submit();">
                            <i className="fa fa-download" /> Tải audio về
                          </a>
                          </form>              </div>
                        <a download className="dlThumb iconDonwload col-md-6 none-padding-right" href="/Upload/images/7a840dd6c2f118af41e0.jpg" target="_blank">
                          <span>Tải hình</span>
                        </a>
                      </div>
                      <div className="col-md-12">
                      </div>
                    </div>
                  </div>
                  <br />
                  <style dangerouslySetInnerHTML={{ __html: "\n        .mejs__poster.mejs__layer {\n            display: block !important;\n        }\n    " }} />
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 tabVideoAudio hash-tabs">
                  <article className="tab-container">
                    <nav className="tab-nav nav nav-tabs">
                      <li
                        style={{ backgroundColor: activeTab === 'MoiNhat' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('MoiNhat')}
                      >
                        <a className="btnTab" title="Mới nhất">
                          <i className="fa fa-upload" /> MỚI NHẤT
                        </a>
                      </li>
                      <li
                        style={{ backgroundColor: activeTab === 'XemNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('XemNhieu')}
                      >
                        <a className="btnTab" title="Xem nhiều">
                          <i className="fa fa-eye" /> NGHE NHIỀU
                        </a>
                      </li>
                      <li
                        style={{ backgroundColor: activeTab === 'TaiNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('TaiNhieu')}
                      >
                        <a className="btnTab" title="Tải nhiều">
                          <i className="fa fa-download" /> TẢI NHIỀU
                        </a>
                      </li>
                    </nav>
                    <div className="tab-pane-container">
                      <section id="MoiNhat" className="homeListVideoUpdate audio" role="tabpanel" aria-labeledby={0} style={{ display: 'block' }}>
                        <table className="table table-striped listAudio ">
                          <tbody>

                            {data?.map((item, index) => (
                              <tr>
                                <td>
                                  <span>{((currentPage - 1) * 8) + index + 1}</span>
                                </td>
                                <td>
                                  <a className="ten-audio" href={`/audio/${item?.Slug_Full}?id=${item?.id}`}>
                                    {item.title}
                                  </a>
                                  <span className="nguoi-giang">
                                    {item.value}
                                  </span>
                                </td>
                                <td> {item.Description} </td>
                                <td className="lefticonListAudio">
                                  <a className="fa fa-headphones " href={`/audio/${item?.Slug_Full}?id=${item?.id}`} />&nbsp;
                                  <a className="fa fa-plus-square   iconDonwload2 btnAddFav" data-id={30397} data-type="audio" data-title={item.title}>
                                  </a>
                                  <form action="/Download/File/30397?type=audio" className id="formDownload-30397" method="post"><input name="__RequestVerificationToken" type="hidden" defaultValue="Mz3OfEmB6XW_8dgTykWzwppRl3mBvRxdDSM3hBjk8YepKpHcdcpHKuUcvVX8VlI2Q-Jddhjr3TcU_22XSLQmk-XwPJ81" />                                <a className="fa fa-download iconDonwload2 btn-downloadfile" onclick="document.getElementById('formDownload-' + 30397).submit();">
                                  </a>
                                  </form>
                                </td>
                              </tr>

                            ))}

                          </tbody>
                        </table>
                        {/*// video */}
                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="pagination-container">
                              <ul className="pagination">
                                {currentPage > 1 && (
                                  <li className="PagedList-skipToLast">
                                    <a onClick={() => handlePageClick(1)}>««</a>
                                  </li>
                                )}
                                {currentPage > 1 && (
                                  <li className="PagedList-skipToNext">
                                    <a onClick={() => handlePageClick(currentPage - 1)} rel="prev">«</a>
                                  </li>
                                )}

                                {/* Display only 10 pagination items */}
                                {[...Array(totalPages)].map((_, index) => {
                                  const page = index + 1;
                                  const startPage = Math.max(1, currentPage - 3); // Start 5 pages before current page
                                  const endPage = Math.min(totalPages, currentPage + 8); // End 5 pages after current page

                                  if (page >= startPage && page <= endPage) {
                                    return (
                                      <li key={page} className={currentPage === page ? 'active' : ''}>
                                        <a onClick={() => handlePageClick(page)}>{page}</a>
                                      </li>
                                    );
                                  }
                                  return null;
                                })}

                                {currentPage < totalPages && (
                                  <li className="PagedList-skipToNext">
                                    <a onClick={() => handlePageClick(currentPage + 1)} rel="next">»</a>
                                  </li>
                                )}
                                {currentPage < totalPages && (
                                  <li className="PagedList-skipToLast">
                                    <a onClick={() => handlePageClick(totalPages)}>»»</a>
                                  </li>
                                )}
                              </ul>

                            </div>
                          </div>
                        </div>
                        <div className="loadingContainer loading" id="loadingTab">
                          <img className="gifLoading" src="/Theme/img/loading.GIF" />
                        </div>
                      </section>
                    </div>
                  </article>
                </div>
              </div>
              {/* //content video */}
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 homeThongBao none-padding-left">
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12  none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC AUDIO</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      <li>
                        <a href="/video/nghi-thuc-nikaya">
                          <i className="fa fa-angle-right" /> Nghi Thức Nikaya
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nghi-thuc-nikaya/2024-7">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/phap-dam">
                          <i className="fa fa-angle-right" /> Pháp Đàm
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/phap-dam/2024-8">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/thien-biet-on">
                          <i className="fa fa-angle-right" /> Thiền Biết Ơn
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/thien-biet-on/2024-9">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/nikaya-khat-thuc">
                          <i className="fa fa-angle-right" /> Nikaya Khất Thực
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nikaya-khat-thuc/2024-10">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/nikaya-trinh-phap">
                          <i className="fa fa-angle-right" /> Nikaya Trình Pháp
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nikaya-trinh-phap/2024-11">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/2-thien-quan">
                          <i className="fa fa-angle-right" /> Thiền Quán
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                        </ul>
                      </li>
                      <li>
                        <a href="/video/meu-dizer-chefe-vao">
                          <i className="fa fa-angle-right" /> Bài giảng cho Tăng Ni
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2007">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2008-2">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2009">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2010">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2011-2">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2012-2">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2013-2">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2014-2">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2015-2">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2016-2">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2017">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2018-2">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2019-2">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/-54">
                              2020
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2021">
                              2021
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/si-ja-roubado-osculou-empatar">
                          <i className="fa fa-angle-right" /> Bài Giảng Theo Bộ
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2-2006">
                              2006
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/umas-alli-alta-viam-ler-por">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2008-3">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2009-2">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2010-2">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2011-3">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2012-3">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2013-3">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2014-3">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2015-3">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2016-3">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2017-3">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2018-3">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2019-5">
                              2019
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/bai-giang-pho-thong-2">
                          <i className="fa fa-angle-right" /> Bài Giảng Phổ Thông
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2024-6">
                              2024
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2005-2">
                              2005
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2006-3">
                              2006
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2007-2">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2008-4">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2009-3">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2010-3">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2011-4">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2012-4">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2013-4">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2014-4">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2015-4">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2016-4">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2017-2">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2018-4">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2019-6">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2020-2">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/soi-sang-2">
                          <i className="fa fa-angle-right" /> Soi Sáng
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/soi-sang-2/2008-8">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2009-8">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2010-8">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2011-9">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2012-9">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2013-9">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2014-9">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2015-9">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2016-5">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2017-4">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2018-5">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2019-4">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2020-3">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/faceis-perdia-tinhas">
                          <i className="fa fa-angle-right" /> Bài giảng tại Am Pháp Ấn
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2022">
                              2022
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/ando-na-tu-acto-tolo-ja">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/pe-ou-ella-es-fila-como">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/na-um-novos-abrir-es-ardor-menos">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2011">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2012">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2013">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2014">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2015">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2016">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2-2017-9">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2018">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2019">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2020">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row" data-wow-delay="0.4s">
                <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                  <a className="playlistWidget" href="/danh-sach-playlist/1">
                    <img src={require("./Theme/img/show_playlist.png")} />
                  </a>
                </div>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">THỐNG KÊ</h5>
                <ul>
                  <li className="text-center">
                    <strong>Chi tiết thống kê</strong>
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Đang truy cập: 1
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Lượt truy cập : {thongKe[0] && thongKe[0].TotalCounter}
                  </li>
                  <li>
                    <i className="fa fa-headphones" />
                    Tổng lượng nghe : {thongKe[0] && thongKe[0].TotalViews}
                  </li>
                  <li>
                    <i className="fa fa-download" />
                    Tổng Download : {thongKe[0] && thongKe[0].TotalDownload}
                  </li>
                  <li className="text-center">
                    <strong>Thống kê hôm nay</strong>
                  </li>
                  <li>
                    <i className="fa fa-users" />
                    Lượt truy cập hôm nay: {thongKe[0] && thongKe[0].countUserVisitToday}
                  </li>
                  <li>
                    <i className="fa fa-cloud-download" />
                    Download trong ngày : {thongKe[0] && thongKe[0].countDownloadToday}
                  </li>
                  <li>
                    <i className="fa fa-user" />
                    <a href="/Dang-nhap">Đăng nhập</a>
                  </li>
                </ul>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">LIÊN KẾT</h5>
                <ul>
                  <li>
                    <i className="fa fa-facebook" />
                    <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                  </li>
                  <li>
                    <i className="fa fa-youtube" />
                    <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>
      <footer>
        <div className="container">
          <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default AudioPage;
